(() => {
  'use strict';
  const configNode = document.getElementById('ra-cro-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = document.querySelector('.product-section[data-product-id="' + config.productId + '"]');
  const meta = root?.querySelector('.product-single__meta');
  if (!root || !meta) return;
  if (root.dataset.raCroReady === 'true') return;
  root.dataset.raCroReady = 'true';
  let pending = false, bar, barSummary, barButton, button, sizeGroup;
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const selectedLabel = group => {
    const input = group?.querySelector('input[type="radio"]:checked');
    const label = input && group.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    return label ? (label.getAttribute('data-ra-label') || input.getAttribute('aria-label') || label.getAttribute('data-ra-original-label') || label.textContent).replace(/\s+/g, ' ').trim() : '';
  };
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  function setupSize(group) {
    const dropdown = group.querySelector('.dropdown-selector');
    if (!dropdown) return;
    let details = dropdown.closest('.ra-cro-sizes');
    if (!details) {
      details = document.createElement('details'); details.className = 'ra-cro-sizes';
      const summary = document.createElement('summary');
      dropdown.before(details); details.append(summary, dropdown);
      details.addEventListener('toggle', () => {
        document.dispatchEvent(new Event('ra:purchase-layout')); schedule();
      });
    }
    const oldButton = dropdown.querySelector('.dropdown-button-gsw');
    if (oldButton) { oldButton.hidden = true; oldButton.style.setProperty('display', 'none', 'important'); }
    text(details.querySelector('summary'), 'Selected size: ' + (selectedLabel(group) || 'Choose a size'));
    sizeGroup = group;
  }
  function ensureBar() {
    if (bar) return;
    bar = document.createElement('aside'); bar.className = 'ra-cro-purchase-bar'; bar.hidden = true;
    bar.setAttribute('aria-label', 'Selected artwork and purchase');
    const info = document.createElement('p');
    barSummary = document.createElement('span'); const price = document.createElement('strong');
    price.dataset.raCroPrice = ''; info.append(price, barSummary);
    barButton = document.createElement('button'); barButton.type = 'button';
    barButton.addEventListener('click', () => {
      // Delegate to the existing Shopify form: preserve variant, quantity and cart behavior.
      if (button && !button.disabled) button.click();
    });
    bar.append(info, barButton); document.querySelector('main').appendChild(bar);
  }
  function reviewDisplay() {
    if (!config.reviewHoldId) return;
    const reviews = document.getElementById('ra-product-reviews');
    const widget = reviews?.querySelector('.jdgm-rev-widg');
    if (!widget) return;
    const summary = window.raCroReviewSummary?.(widget);
    if (!summary) return;
    widget.querySelectorAll('.jdgm-histogram__row[data-frequency]').forEach(row => {
      const rating = Number(row.getAttribute('data-rating'));
      const original = Number(row.getAttribute('data-frequency'));
      const count = Math.max(0, original - (rating === 5 ? 1 : 0));
      const percentage = Math.round(count / summary.count * 100);
      text(row.querySelector('.jdgm-histogram__frequency'), String(count));
      const fill = row.querySelector('.jdgm-histogram__bar-content');
      if (fill && fill.style.width !== percentage + '%') fill.style.width = percentage + '%';
      const control = row.querySelector('[role=button]');
      const label = percentage + '% (' + count + ') reviews with ' + rating + ' star rating';
      if (control && control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label);
    });
    // Keep the source widget and its review record intact. Display counts describe the visible set.
    const rating = meta.querySelector('.ra-product-rating');
    if (rating) {
      const native = rating.querySelector('.jdgm-prev-badge');
      if (native) native.style.setProperty('display', 'none', 'important');
      let link = rating.querySelector('.ra-cro-review-link');
      if (!link) {
        link = document.createElement('button'); link.type = 'button'; link.className = 'ra-cro-review-link';
        link.addEventListener('click', () => { reviews.open = true; reviews.scrollIntoView({block:'start', behavior:'smooth'}); });
        rating.appendChild(link);
      }
      text(link, summary.rating.toFixed(2) + ' / 5 · ' + summary.count + ' reviews');
    }
    let note = reviews.querySelector('.ra-cro-review-hold-note');
    if (!note) { note = document.createElement('p'); note.className = 'ra-cro-review-hold-note'; reviews.querySelector('summary').after(note); }
    text(note, 'One review is not displayed while its product match is being checked.');
  }
  function update() {
    pending = false;
    const group = meta.querySelector('.swatch--gl[data-option-index="0"][data-ra-size-ready="true"]');
    if (group) setupSize(group);
    button = meta.querySelector('form [data-add-to-cart]');
    const form = button?.closest('form');
    const room = meta.querySelector('.seeonwall-button');
    if (form && room && !room.classList.contains('ra-cro-room-secondary')) {
      room.classList.add('ra-cro-room-secondary');
      const control = room.querySelector('button');
      if (control) {
        control.style.setProperty('background', '#fff', 'important');
        control.style.setProperty('color', '#60483d', 'important');
        control.style.setProperty('border', '1px solid #b3a296', 'important');
      }
    }
    if (config.productId === 9026496757912 || config.productId === 9275853668504) {
      let note = root.querySelector('.ra-cro-image-note');
      if (!note) { note = document.createElement('p'); note.className = 'ra-cro-image-note'; if (form) form.after(note); else meta.appendChild(note); }
      const dimensions = selectedLabel(group);
      const message = config.productId === 9026496757912
        ? 'Square artwork. Room images are styling examples; check your selected size and frame in View in Your Room.'
        : 'Wide-format room styling example. Order dimensions: ' + dimensions + '. Use View in Your Room to check your selected size.';
      text(note, message);
    }
    if (button) {
      ensureBar();
      const r = button.getBoundingClientRect();
      const show = matchMedia('(max-width:749px)').matches && !meta.querySelector('.ra-cro-sizes[open]') && !document.body.classList.contains('ra-purchase-clearance') && scrollY > 120 && !(r.top >= 0 && r.bottom <= innerHeight);
      bar.hidden = !show; document.body.classList.toggle('ra-cro-sticky-visible', show);
      const price = meta.querySelector('[data-product-price]') || meta.querySelector('.product__price:not(.product__price--compare)');
      text(bar.querySelector('[data-ra-cro-price]'), price?.textContent.trim() || '');
      text(barSummary, [selectedLabel(sizeGroup), selectedLabel(meta.querySelector('.swatch--gl[data-option-index="1"]'))].filter(Boolean).join(' · '));
      text(barButton, button.disabled ? 'Unavailable' : 'Add to cart'); barButton.disabled = button.disabled;
      const preview = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
      const previewRect = preview?.getBoundingClientRect();
      const offset = previewRect && previewRect.bottom > 0 && previewRect.top < innerHeight ? Math.min(100, previewRect.height) : 0;
      const value = offset + 'px'; if (bar.style.getPropertyValue('--ra-cro-preview-offset') !== value) bar.style.setProperty('--ra-cro-preview-offset', value);
    }
    const runtime = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('shopify-agent-runtime');
    const chatRoot = runtime?.shadowRoot;
    if (chatRoot) {
      if (!chatRoot.getElementById('ra-cro-chat-clearance')) {
        const style = document.createElement('style'); style.id = 'ra-cro-chat-clearance';
        style.textContent = ':host([data-ra-cro-clearance]) [part~=activator]{visibility:hidden!important;pointer-events:none!important}';
        chatRoot.appendChild(style);
      }
      runtime.toggleAttribute('data-ra-cro-clearance', document.body.getAttribute('data-ra-hide-chat') === 'true' || document.body.classList.contains('ra-purchase-clearance'));
    }
    reviewDisplay();
  }
  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => {
      const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return el && !el.closest('.ra-cro-purchase-bar,.ra-cro-image-note,.ra-cro-review-hold-note,.ra-cro-review-link') &&
        (el === document.body || el.closest('.globo-swatch-product-detail,form,.ra-product-rating,#ra-product-reviews') ||
        [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches('.globo-swatch-product-detail,.seeonwall-button') || n.querySelector('.globo-swatch-product-detail'))));
    })) schedule();
  });
  observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['checked','disabled','data-ra-label','data-number-of-reviews','data-average-rating','data-ra-hide-chat']});
  root.addEventListener('change', event => {
    if (event.target.matches('input[type="radio"]') && event.isTrusted) {
      const details = event.target.closest('.ra-cro-sizes'); if (details) details.open = false;
    }
    schedule();
  });
  document.addEventListener('variant:change', schedule);
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('load', schedule, {once:true});
  update();
})();
